import type { HelpFile } from '../../types/help'
import { TypeDetailTestIds } from '../../../testids/TypeDetailTestIds'

export const typeDetailHelp: HelpFile = {
  docPage: '/docs/admin/types',
  texts: {
    [TypeDetailTestIds.typeDetailPage]: 'Detail view of one enumerated type — its values, translations, and which entities use it.',
    [TypeDetailTestIds.btnAddValue]: 'Add a new value to this type. Values cannot be deleted once referenced — set them inactive instead.',
    [TypeDetailTestIds.btnSetInactive]: 'Mark this type value as inactive. Existing references stay intact, but the value disappears from new pickers.',
    [TypeDetailTestIds.btnCloseView]: 'Close this detail view and return to the type list.',
    [TypeDetailTestIds.btnCancelDelete]: null,
    [TypeDetailTestIds.btnConfirmDelete]: null,
    [TypeDetailTestIds.btnEditTranslations]: null,
  },
}
